import { t } from "./localization/i18n";
import { enums } from "./enums";
import moment from "moment";

//------- Image --------
export const appLogo = require("@/assets/logo/logo_notext.png");
export const appLogoText = require("@/assets/logo/logo.png");
export const categoryImg = require("@/assets/default/default_category.png");
export const courseImg = require("@/assets/default/default_course.png");
export const defaultProfile = require("@/assets/default/default_profile.png");
export const lineQRCode = require("@/assets/default/line_qrcode.png");

export const fileType = [
  { value: "image", icon: require("@/assets/fileType/img.png") },
  { value: "video", icon: require("@/assets/fileType/video.png") },
  { value: "doc", icon: require("@/assets/fileType/doc.png") },
  { value: "sheet", icon: require("@/assets/fileType/sheet.png") },
  { value: "pdf", icon: require("@/assets/fileType/pdf.png") },
  { value: "ppt", icon: require("@/assets/fileType/ppt.png") },
  { value: "default", icon: require("@/assets/fileType/file.png") },
];
export const today = moment().format("YYYY-MM-DD");

// Date & Month List
export const dayTH = [
  "อาทิตย์",
  "จันทร์",
  "อังคาร",
  "พุธ",
  "พฤหัสบดี",
  "ศุกร์",
  "เสาร์",
];

export const dayEn = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const monthTH = [
  "มกราคม",
  "กุมภาพันธ์",
  "มีนาคม",
  "เมษายน",
  "พฤษภาคม",
  "มิถุนายน",
  "กรกฎาคม",
  "สิงหาคม",
  "กันยายน",
  "ตุลาคม",
  "พฤศจิกายน",
  "ธันวาคม",
];

export const monthEn = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
export const shortMonthTH = [
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
];

export const shortMonthEn = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

// ---- Payment ----

const paymentType = enums.PAYMENTMETHOD;

export const paymentMethods = [
  {
    value: [paymentType.INTERNET_BANKING, paymentType.CORPORATE_BANKING],
    name: "payment.bank",
    icon: "noto:bank",
  },
  {
    value: [paymentType.CREDIT_CARD, paymentType.CREDIT_CARD_INSTALLMENT],
    name: "payment.creditCard",
    icon: "twemoji:credit-card",
  },
  {
    value: [paymentType.QR_CODE_PAYMENT],
    name: "payment.qrPayment",
    icon: "lucide:qr-code",
  },
  {
    value: [paymentType.CASH],
    name: "payment.cash",
    icon: "flat-color-icons:money-transfer",
  },
  {
    value: [paymentType.TRANSFER],
    name: "payment.schoolBank",
    icon: "emojione:school",
  },
];
export const paymentChoice = {
  BANK: {
    value: paymentType.TRANSFER,
    name: "payment.schoolBank",
    icon: "emojione:school",
  },
  CARD: {
    value: paymentType.CREDIT_CARD,
    name: "payment.creditCard",
    icon: "twemoji:credit-card",
  },
  CASH: {
    value: paymentType.CASH,
    name: "payment.cash",
    icon: "flat-color-icons:money-transfer",
  },
  NOTI: {
    value: "NOTIFICATION",
    name: "enroll.sendPaymentReminder",
    icon: "fluent-emoji:bell",
  },
};

export const paymentStatus = [
  { value: "SUCCESS", name: t("paymentStatus.success") },
  { value: "PENDING", name: t("paymentStatus.pending") },
  { value: "CANCEL", name: t("paymentStatus.cancel") },
];

// Leave + Check In
export const studentCheckInStatus = {
  PUNCTUAL: { label: "attendanceStatus.onTime", color: "success" },
  LATE: { label: "attendanceStatus.late", color: "orange" },
  EMERGENCY_LEAVE: {
    label: "attendanceStatus.emergencyLeave",
    color: "light-blue",
  },
  ABSENT: { label: "attendanceStatus.absent", color: "error" },
  LEAVE: { label: "attendanceStatus.leave", color: "light-blue" },
  NOT_CHECKIN: { label: "message.notSpecified", color: "black" },
};

export const leaveTimeOptions = {
  FULL: "leaveManagement.leaveAllDay",
  MORNING: "leaveManagement.leaveAM",
  AFTERNOON: "leaveManagement.leavePM",
};

export const leaveTypeOptions = {
  SICK: "leaveManagement.sickLeave",
  ANNUAL: "leaveManagement.vacationLeave",
  BUSSINESS: "leaveManagement.personalLeave",
};
export const dayOfWeek = [
  { value: 0, name: "day.sun", shortName: "shortDay.sun", color: "red" },
  { value: 1, name: "day.mon", shortName: "shortDay.mon", color: "amber" },
  { value: 2, name: "day.tue", shortName: "shortDay.tue", color: "pink" },
  { value: 3, name: "day.wed", shortName: "shortDay.wed", color: "green" },
  {
    value: 4,
    name: "day.thu",
    shortName: "shortDay.thu",
    color: "deep-orange",
  },
  { value: 5, name: "day.fri", shortName: "shortDay.fri", color: "light-blue" },
  {
    value: 6,
    name: "day.sat",
    shortName: "shortDay.sat",
    color: "deep-purple",
  },
];
export const reserveStatus = [
  {
    value: enums.RESERVESTATUS.WAITING,
    label: "courseStatus.pending",
    icon: "mdi-clock-time-eight",
    color: "blue",
  },
  {
    value: enums.RESERVESTATUS.CONFIRMED,
    label: "courseStatus.complete",
    icon: "mdi-check-circle",
    color: "green",
  },
  {
    value: enums.RESERVESTATUS.CANCELLED,
    label: "courseStatus.cancel",
    icon: "mdi-close-circle",
    color: "red",
  },
];

export const SortOption = [
  {
    text: "reserve.newest",
    icon: "octicon:sort-desc-16",
    value: "DESC",
  },
  {
    text: "reserve.oldest",
    icon: "octicon:sort-asc-16",
    value: "ASC",
  },
];
